import { useNewDeals } from '@client/components/mylounge/newDeals';
import { useLeavingSoonData } from '@client/components/mylounge/leavingSoon/hooks/useLeavingSoonData';
import type { CustomCampaignsConfig } from './CustomCampaignsView';

export type ActiveFeature = 'newDeals' | 'leavingSoon';

export const useCustomCampaignsData = (
    activeFeature: ActiveFeature | null,
): CustomCampaignsConfig | null => {
    const { newDealsCampaigns } = useNewDeals();
    const { leavingSoonCampaigns } = useLeavingSoonData();

    if (activeFeature === 'newDeals') {
        return {
            page: 'new_deals',
            translationScope: 'newDealsToday',
            viewTestId: 'new-deals-today-view',
            idPrefix: 'new_deals',
            trackCreativeName: 'new_deals',
            trackItemListName: 'new_deals',
            campaigns: newDealsCampaigns,
        };
    }

    if (activeFeature === 'leavingSoon') {
        return {
            page: 'ending_soon_deals',
            translationScope: 'leavingSoon',
            viewTestId: 'leaving-soon-view',
            idPrefix: 'leaving_soon',
            trackCreativeName: 'ending_soon_deals',
            trackItemListName: 'ending_soon_deals',
            campaigns: leavingSoonCampaigns,
        };
    }

    return null;
};
